import { create } from "zustand";

interface ConnectionState {
  connectedElement: { stop: () => void } | null;
  setConnectedElement: (element: { stop: () => void } | null) => void;
}

const useConnectionStore = create<ConnectionState>((set) => ({
  connectedElement: null,
  setConnectedElement: (element) => set({ connectedElement: element }),
}));

export { useConnectionStore };
